import React from 'react';
import MainPage from './MainPage';

const Staff = () => {
  return <MainPage tag='STAFF' title='STAFF' url='/staff'/>;
}

export default Staff;